'use client';

import { c as _c } from "react/compiler-runtime";
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { Container, MotionBlock } from './shared';
export function TrustStrip() {
  const $ = _c(4);
  const c = useCadrinoCopy();
  let t0;
  if ($[0] !== c.trustStrip.items) {
    t0 = c.trustStrip.items.map(_temp);
    $[0] = c.trustStrip.items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <section className="border-b border-white/[0.08] bg-cadrino-surface/20 py-8"><Container><div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">{t0}</div></Container></section>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(item, index) {
  return <MotionBlock key={item.title} delay={index * 0.03}><div className="text-center md:text-left"><p className="text-sm font-semibold text-slate-100">{item.title}</p><p className="mt-1 text-xs leading-relaxed text-cadrino-muted">{item.description}</p></div></MotionBlock>;
}